export default __webpack_public_path__ + "static/media/shape_waves.45dc754f.svg";